export default __webpack_public_path__ + "static/media/ip0X.ca214fd1.svg";